import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Type } from '@angular/core';

import { IS_EXTERNAL_PAGE_TOKEN } from '@anecdotes/auth-core';
import { AbstractUserEventConfig } from './abstract-user-event-config/abstract-user-event-config.service';
import { UserEventService } from './user-event/user-event.service';
import { AmplitudeService } from './amplitude/amplitude.service';
import { RouterExtensionService } from './router-extension/router-extension.service';

@NgModule({
  imports: [CommonModule],
})
export class UserEventModule {
  static forRoot(configType: Type<AbstractUserEventConfig>, isExternalPage?: boolean): ModuleWithProviders<UserEventModule> {
    return {
      ngModule: UserEventModule,
      providers: [
        { provide: AbstractUserEventConfig, useClass: configType },
        { provide: IS_EXTERNAL_PAGE_TOKEN, useValue: isExternalPage },
        UserEventService,
        AmplitudeService,
        RouterExtensionService,
      ],
    };
  }
}
